<template>
    <div class="configurator">
        <Instructions v-if="currentStage == 1"></Instructions>
        <Popup v-if="showSurvey == true" @close="showSurvey = false" title="Umfrage">
            <p>Sehr geehrte Damen und Herren</p>
            <p>Vielen Dank, dass Sie den Education Cloud Konfigurator benutzt haben. Ihre Zusammenfassung sollten Sie in Kürze per E-Mail bekommen.</p>
            <p>Wir würden uns freuen, wenn Sie knapp 10 Minuten Ihrer wertvollen Zeit aufwenden würden, um diesen Fragebogen zu beantowrten. Ihre Antworten helfen uns sehr, unsere Qualität der Beratug für Sie zu steigern.</p>
            <router-link class="button" :to="'/survey'" exact v-on:click.native="$route.params.lisaType = lisaType;$route.params.ssid = ssid;">Ja</router-link> <button class="button no-filling" @click="showSurvey = false;blockSurvey = true">Nein</button>
        </Popup>
        <button v-if="currentStage >= 1" class="stepButton clickable" :class="{ active: currentStage == 1 }" @click="setStage(1)">I</button>
        <button v-if="currentStage >= 1" class="stepButton clickable" :class="{ active: currentStage == 2 }" @click="setStage(2)">II</button>
        <button v-if="currentStage >= 1" class="stepButton" :class="{ active: currentStage == 3 }">III</button>
        <h1>{{ titles[currentStage] }}</h1>
        <div class="container">
            <transition name="fade" mode="out-in">
                <PreSurvey
                    v-if="currentStage == 0"
                    @next="lisaType = $event;setStage(1)"
                ></PreSurvey>
                <Selector
                    v-if="currentStage == 1"
                    @next="setStage(2)"
                ></Selector>
                <Summary
                    v-if="currentStage == 2"
                    @back="setStage(1)"
                    @next="setStage(3)"
                    :lisaType="lisaType"
                    :ssid="ssid"
                ></Summary>
                <Finish
                    v-if="currentStage == 3"
                >
                </Finish>
            </transition>
        </div>
    </div>
</template>

<script>
    import Selector from './selector/index.vue';
    import Summary from './summary.vue';
    import Finish from './finish.vue';
    import Instructions from '../Instructions.vue';
    import PreSurvey from './survey/PreSurvey.vue';
    import Popup from '../Popup.vue';
    import { uuid } from 'vue-uuid';

    export default {
        components: {
            Selector,
            Summary,
            Finish,
            Instructions,
            PreSurvey,
            Popup
        },
        data(){
            return {
                currentStage: 0,
                titles: {
                    0: "In welcher Funktion sind Sie im Bildungsbreich tätig?",
                    1: "Klassenzimmer konfigurieren",
                    2: "Zusammenfassung erhalten",
                    3: "Persönliche Beratung"
                },
                lisaType: null,
                showSurvey: false,
                ssid: uuid.v4().substring(0,8),
                blockSurvey: false
            }
        },
        methods: {
            setStage(stage){
                this.currentStage = stage
            },
            openSurvey() {
                if(this.currentStage == 3 && this.blockSurvey == false) {
                    setTimeout(() => {this.showSurvey = true}, 5000)
                }
            }
        },
        updated: function() {
            this.openSurvey()
        }
    }
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .4s ease;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .no-filling {
        background-color: unset;
        color: $blue;
        border: 2px solid $blue;
        box-sizing: border-box;
        padding: 8px 20px;
    }
    .no-filling:hover {
        transition: all .4 ease;
        background-color: $blue;
        color: white;
    }

    .stepButton {
        outline: none;
        border: 0;
        background-color: $lightblue;
        color: white;
        width: 75px;
        line-height: 75px;
        font-size: 55px;
        display: inline-block;
        margin-right: 15px;
        font-weight: 600;
        float: left;

        &.active {
            background-color: $blue;
        }

        &.clickable {
            cursor: pointer;
        }
    }

    .devskip {color:white}

    @media (max-width: 1100px){
        .configurator {
            h1 {
                clear: both;
                padding-top: 40px;
            }
        }
    }

    @media (max-width: 380px){
        .stepButton {
            width: 100%;
            float: none;
        }
    }
</style>
